module.exports = __webpack_public_path__ + "img/VetoSans-Medium.cf89870a.svg";